import { UiSpacerModel } from "../../models";

import { Spacer } from "./UiSpacer.styles";

export type UiSpacerProps = {
    readonly model: UiSpacerModel;
};

const UiSpacer = ({
    model: {
        content: { size }
    }
}: UiSpacerProps) => {
    const spacing = {
        "1": { desktop: "0.5rem", mobile: "0.25rem" },
        "2": { desktop: "1rem", mobile: "0.5rem" },
        "3": { desktop: "1.5rem", mobile: "1rem" },
        "4": { desktop: "2rem", mobile: "1.5rem" },
        "5": { desktop: "3rem", mobile: "2rem" },
        "6": { desktop: "4rem", mobile: "3rem" },
        "7": { desktop: "6rem", mobile: "4rem" },
        "8": { desktop: "8rem", mobile: "6rem" }
    };

    const getSpacingSize = (
        size: keyof typeof spacing,
        screen: "desktop" | "mobile"
    ) => spacing[size][screen];
    return (
        <Spacer
            desktop={getSpacingSize(size, "desktop")}
            mobile={getSpacingSize(size, "mobile")}
        />
    );
};

export default UiSpacer;
